import FormModule from "components/Modules/Documents/FormModule"
import {
  createOrUpdateFirestoreDocument,
  getFirestoreDocument,
} from "helpers/Firestore"
import {
  normalizeWidgetData,
  prepareWidgetDataForSave,
} from "../budgetWidgetData"

const CityBudgetFiles = () => {
  return (
    <FormModule
      noCancel
      form={{
        title: "Files",
        fields: [
          {
            ID: "budget-files-table",
            Type: "Editable Table",
            Name: "WidgetData.dataList.links",
            Label: "Files",
            Columns: [
              {
                Name: "filetype",
                Label: "File type",
                Editable: true,
                DefaultValue: "pdf",
              },
              { Name: "name", Label: "Name", Editable: true },
              { Name: "url", Label: "URL", Editable: true },
            ],
            DeletedName: "DeletedFiles",
            Creatable: true,
            Orderable: true,
          },
        ],
        getDefaultValues: async ({ firebaseUID }) => {
          const moduleDoc = await getFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules/136`,
          })

          return {
            WidgetData: normalizeWidgetData(moduleDoc?.WidgetData || {}),
            DeletedFiles: [],
          }
        },
        onSubmit: async (values, { firebaseUID }) => {
          const widgetData = prepareWidgetDataForSave(values.WidgetData || {})

          await createOrUpdateFirestoreDocument({
            path: `City/Cities/DataBase/${firebaseUID}/Modules`,
            values: {
              ID: "136",
              WidgetData: widgetData,
            },
          })

          return values
        },
      }}
      ID={"136"}
    />
  )
}

export default CityBudgetFiles
